import * as React from "react";
const SvgFiRrScannerGun = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scanner-gun_svg__a)">
      <path
        fill="#062147"
        d="M17 1a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1m6 3h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2m0 15h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2m0-8h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2m-.5-4h-4a1.5 1.5 0 1 0 0 3h4a1.5 1.5 0 1 0 0-3m0 8h-4a1.5 1.5 0 1 0 0 3h4a1.5 1.5 0 1 0 0-3m.5 7h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2M15 6v4c0 1.654-1.346 3-3 3H9.719l-.672 2.001A.999.999 0 0 1 9 17h-.625l-1.523 4.532c-.461 1.48-1.846 2.44-3.337 2.44a3.506 3.506 0 0 1-3.342-4.539l2.377-7.076A5 5 0 0 1-.001 7.999 5.007 5.007 0 0 1 5 3h7c1.654 0 3 1.346 3 3m-7.391 7H5q-.276 0-.544-.03l-2.379 7.078c-.238.768.205 1.61.994 1.856a1.5 1.5 0 0 0 1.878-.987zM13 6c0-.551-.448-1-1-1H5C3.346 5 2 6.346 2 8s1.346 3 3 3h7c.552 0 1-.449 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scanner-gun_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScannerGun;
